module.exports = __webpack_public_path__ + "img/language-default.6431e6d8.svg";